<template>
  <div>
    <h5>Cancel order</h5>
    <div class="mb-4">
      <p v-if="!orderFound && !submitted && !cancelled">
        Enter your order ID to see if your order is eligible to be cancelled.
      </p>
      <p v-else-if="submitted && !cancelled">
        <template
          v-if="
            eligibilityMessage === '' &&
            project() === 'kitlocker-main-site-364199'
          "
        >
          Sorry, we were unable to find an order matching that ID. Try
          <a href="https://myorders.kitlocker.shop/login/"
            >https://myorders.kitlocker.shop/login/</a
          >.
        </template>
        <template v-else>
          {{ eligibilityMessage }}
        </template>
      </p>
      <p v-else>
        Your order has successfully been cancelled and your money should be back
        in your account within 5-10 days.
      </p>
    </div>
    <tml-form ref="findOrderForm" form-name="find-order-form">
      <div v-if="!submitted && !cancelled">
        <tml-input
          v-model="orderId"
          :validation-rules="{required: true}"
          placeholder="Order ID (e.g. 123123)"
          field-name="orderId"
          type="text"
          @submit="onSubmit"
        />
        <tml-button fill text="Submit" :loading="loading" @click="onSubmit" />
      </div>
    </tml-form>
    <tml-form ref="cancelOrderForm" form-name="cancel-order-form">
      <div v-if="submitted && !cancelled && canCancel">
        <tml-input
          v-model="emailAddress"
          :validation-rules="{required: true, email: true}"
          placeholder="Email address"
          field-name="emailAddress"
          type="email"
        />
        <tml-input
          v-if="confirmZip"
          v-model="zip"
          :validation-rules="{required: true}"
          placeholder="Postcode / zip"
          field-name="zip"
        />
        <tml-re-captcha
          ref="captcha"
          :class="{'mb-4': recaptchaMargin}"
          action="subdomains_order_cancel"
          @rendered="recaptchaMargin = true"
        />
        <tml-button
          fill
          text="Cancel order"
          :loading="loading"
          @click="cancelOrder"
        />
      </div>
    </tml-form>
  </div>
</template>

<script>
import {formatUrl} from '@teemill/common/helpers';

export default {
  name: 'HelpCancelOrder',

  data() {
    return {
      zip: null,
      orderId: null,
      loading: false,
      orderFound: null,
      submitted: false,
      cancelled: false,
      confirmZip: false,
      emailAddress: null,
      recaptchaMargin: false,
      eligibilityMessage: '',
    };
  },

  methods: {
    onSubmit() {
      this.$refs.findOrderForm.validateAll().then(success => {
        if (success) {
          this.loading = true;

          this.axios
            .post(formatUrl('/omnis/v3/contact/cancel-order-eligibility/'), {
              orderId: this.orderId,
            })
            .success(data => {
              if (data) {
                this.submitted = true;
                this.orderFound = data.orderFound;
                this.confirmZip = data.confirmZip;
                this.canCancel = data.canCancel;
                this.eligibilityMessage = data.message;
              }
            })
            .validation(message => {
              if (message) {
                snackbar.error(message);
              }
            })
            .oops()
            .finally(() => {
              this.loading = false;
              this.submitted = true;
            });
        }
      });
    },

    cancelOrder() {
      if (!this.loading) {
        this.$refs.captcha.recaptcha
          .ifHuman(recaptcha => {
            this.loading = true;

            this.axios
              .post(
                formatUrl(
                  `/omnis/v3/frontend/retex/cancel-order/${this.orderId}`
                ),
                {
                  emailAddress: this.emailAddress,
                  zip: this.zip,
                  v3captchaToken: recaptcha.v3Token,
                  v2captchaToken: recaptcha.v2Token,
                }
              )
              .then(({data}) => {
                if (data.failure === true) {
                  this.showErrorSnackBar(data.message);
                } else {
                  this.cancelled = true;
                }
                this.loading = false;
              })
              .catch(({response}) => {
                if (response && response.data && response.data.message) {
                  this.showErrorSnackBar(response.data.message);
                } else {
                  this.showErrorSnackBar();
                }

                this.loading = false;
              })
              .finally(() => {
                if (this.$refs.captcha) {
                  this.$refs.captcha.recaptcha.reload();
                }
              });
          })
          .ifBot(() => {
            this.loading = false;
          });
      }
    },

    showErrorSnackBar(message) {
      this.$dialogs.showSnackBar({
        type: 'error',
        message:
          message ||
          'Oops... looks like something went wrong. Please try again.',
      });
    },

    project() {
      return (
        this.$project?.active?.id || this.$store.state.subdomain?.project?.id
      );
    },
  },
};
</script>
